import React from 'react';
import axios from 'axios';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import VideoPlayer from "./video_player.jsx"
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Renditions from './renditions.jsx';
import VideoInfo from './video_info.jsx';
import VideoClusterInfo from './video_cluster_info.jsx';
import ClusterCard from './cluster_card.jsx';

//import { withAuthenticator } from 'aws-amplify-react';

const styles = theme => ({
    root: {
        width: '100%',
    }
});

class Video extends React.Component {
    state = {
        video: {},
        loading: true,
    };

    componentDidMount() {
        axios.get(`${process.env.REACT_APP_API_URL}/api/video/${this.props.match.params.id}`)
            .then(res => {
                const video = res.data;

                this.setState({ video, loading: false })
            })
    }

    render() {
        const { classes  } = this.props;
        const { video } = this.state;

        return (
            <div className={classes.root}>
                <Typography variant="headline" gutterBottom>{video && video.fields && video.fields.title}</Typography>
                <Grid container className={classes.gridContainer} spacing={16}>
                    <Grid item lg={6} md={12}>
                        {video && video.fields && (
                            <Renditions video={video} />
                        )}
                    </Grid>
                    <Grid item lg={6} md={12}>
                        <VideoInfo video={video} />
                    </Grid>
                </Grid>
                <Grid container className={classes.gridContainer} spacing={16}>
                    <Grid item xs={12}>
            `           {video && video.fields && (
                            <VideoClusterInfo video={video} />
                        )}
                    </Grid>
                </Grid>

            </div>
        );
    }
}


export default withStyles(styles)(Video);



// WEBPACK FOOTER //
// ./src/components/video.jsx